// extracted by mini-css-extract-plugin
export default {"hide":"CIrZ3d","host":"jWqzXY","inlineContent":"xjdG0O","icon":"wIidXn","name":"QC7iSq"};